import Web3 from "web3";
import abi from "./ropsten-abit.json";
import y5Abi from "./abiY5.json";
import Moralis  from "moralis";

const address = process.env.REACT_APP_CONTRACT_ADDRESS;
const contractOpt = {
    contractAddress:address,
    abi:abi,
}
let  AlphaOctopusContract, walletAddress;




export const getDetail  = async () => {
    try {
        //get user address using web3
        const web3 = new Web3(Moralis.provider);
AlphaOctopusContract = new web3.eth.Contract(abi, address);
        const salePrice = await AlphaOctopusContract.methods.PRICE().call();
        const presalePrice = await AlphaOctopusContract.methods.PRESALE_PRICE().call();
        const saleStart = await AlphaOctopusContract.methods.SALE_START().call();
        const presaleStart = await AlphaOctopusContract.methods.PRESALE_START().call();
        const isPresaleOpen = await AlphaOctopusContract.methods.isPresaleOpen().call();
        const isPaused = await AlphaOctopusContract.methods.isPaused().call();
        const totalMint = await AlphaOctopusContract.methods.totalSupply().call();
        const maxPublic = await AlphaOctopusContract.methods.MAX_BY_MINT().call();
        const maxPrivate = await AlphaOctopusContract.methods.MAX_BY_MINT_WHITELIST().call();
        const maxReserved = await AlphaOctopusContract.methods.MAX_RESERVE_COUNT().call();
        const maxElements = await AlphaOctopusContract.methods.MAX_ELEMENTS().call();


        const data = {
            salePrice, presalePrice,
            salePriceETH: web3.utils.fromWei(salePrice),
            presalePriceETH: web3.utils.fromWei(presalePrice),
            saleStart: Number(saleStart), 
            presaleStart: Number(presaleStart), 
            isPresaleOpen, 
            isPaused, 
            totalMint,
            maxElements, 
            maxPublic, 
            maxPrivate, 
            maxReserved,
        }

        return data;

    } catch (error) {
        console.error(error)
    }
}

export const getUserDetail = async() => {
    try {
        const u = Moralis.User.current();
        const web3 = new Web3(Moralis.provider);
AlphaOctopusContract = new web3.eth.Contract(abi, address);
        // get network
        const network = await web3.eth.net.getNetworkType();
        const balance = await web3.eth.getBalance(walletAddress).then((res) => res?.toString());

        const user = {
            address: walletAddress, 
            balance: web3.utils.fromWei(balance, 'ether'),
            network: network
        }

        return user;
    } catch (error) {
        console.log(error);
    }
}

export const mint = async (count, value) => {
    try {
        const user = Moralis.User.current();
        if(!user) {
            throw new Error("User not found");
        }
        else {
            // await Moralis.enableWeb3({provider:"walletconnect"});
            const web3 = new Web3(Moralis.provider);
            const contract = new web3.eth.Contract(abi, address);
            
            const priceInWei = web3.utils.toWei(value.toString(), 'ether');
        console.log('user mint', user.get('ethAddress'),contract, priceInWei);
        const mint = await contract.methods.mint(count).send({from:user?.get("ethAddress"), value: priceInWei})
        // const mint = await Moralis.executeFunction({...contractOpt, functionName:'mint', params:{_count: count}, from:user?.get('ethAddress'), msgValue: priceInWei})
        // await mint.wait();
        return mint;

        }
    } catch (error) {
        console.error(error)
    }
}
export const presaleMint = async (count, value) => {
    try {
        const user = Moralis.User.current();
        if(!user) {
            throw new Error("User not found");
        }
        // check authenticated or not

        // if(user){
            // const web3 = new Web3(Moralis.provider);
            // const contract = new web3.eth.Contract(abi, address);
            const priceInWei = Moralis.Units.ETH(value.toString(), 'ether');
            console.log('user presale mint', count, priceInWei);
            // const mint = await contract.methods.mint(count).send({from:user?.get("ethAddress"), value: priceInWei});
            const mint = await Moralis.executeFunction({...contractOpt, functionName:'presaleMint', params:{_count: count}, from:user?.get('ethAddress'), msgValue: priceInWei})
            await mint.wait();
            console.log('tx mint', mint)
            return mint;
 
    } catch (error) {
        console.error(error)
    }
}

export const getY5Balance = async (address, provider) => {
    try {
        const web3 = new Web3(provider);
        const Y5Contract = new web3.eth.Contract(y5Abi, "0xCBd8aECe0c920eEF3F215ad4e7319052Bd8eaa74");
        console.log('Y5Contract', Y5Contract, "0xCBd8aECe0c920eEF3F215ad4e7319052Bd8eaa74");
        const balance = await Y5Contract.methods.balanceOf(address).call();
        console.log("balance", balance);
        return balance;
    } catch (error) {
        console.error(error)
    }
}